import styled from "styled-components";
interface StyledButtonProps {
  isFull?: boolean;
}
export const StyledButton = styled.div<StyledButtonProps>`
  ${({ isFull }) => isFull && "width: 100%;"}

  .button-edit-common {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1e3665;
    color: #ffffff;
    padding: 0px 8px;
    font-size: inherit;
    font-weight: 600;
    cursor: pointer;
    height: 40px;
    border-radius: 2px;
    min-width: 60px;
    line-height: 1;
    box-sizing: border-box;
    border: 1px solid transparent;
    &.btn-save-error:disabled {
      background-color: #ffccff !important;
      color: #ffffff !important;
    }
    .button-content {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      gap: 6px;
    }

    .button-loading,
    .button-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .button-text {
      display: block;
      line-height: 1;
      white-space: nowrap;
      transform: translateY(0px);
    }

    &:hover {
      color: #40a9ff;
    }
    &.hidden {
      background-color: transparent;
    }
    &:disabled:not(.btn-loading) {
      background-color: #d9dde5;
      cursor: not-allowed;
      color: #9ca3af !important;
      font-weight: 400;
    }
    &.btn-loading {
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.8;
    }
    &.notEditable {
      cursor: default;
      background-color: #d9dde5;
    }
    .icon {
      display: flex;
      align-items: center;
    }
  }

  .btn-delete-cm {
    background-color: #ff4d4f;
    color: #fff;
    border: none;
    padding: 6px;
    border-radius: 2px;
    cursor: pointer;
  }

  .btn-delete-cm:hover {
    background-color: #d9363e;
  }

  .btn-delete-cm:disabled {
    cursor: not-allowed;
  }
`;
